




























import PageHeader from '@/components/PageHeader'
import BasicElement from '@/components/BasicElement'
import PageFooter from '@/components/PageFooter'
import rootable from '@/mixins/rootable.coffee'

export default {
    name: 'Page',
    
    mixins: [rootable]

    components:
        BasicElement: BasicElement
        PageHeader: PageHeader
        PageFooter: PageFooter

    data: ->
        documentId: '' 
        fields: @defaultFields()

    #watch:
    #    $route: (to, from) ->
    #        @fields = @defaultFields()
    #        @getContent to.params.uid

    #metaInfo: ->
    #    title: @$prismic.richTextAsPlain @fields.meta_title
    #   meta: [
    #        name: 'description',
    #        vmid: 'description',
    #        content: @$prismic.richTextAsPlain @fields.meta_description
    #    ]

    computed:
        headerId: ->
            if @fields.default_header is 'Standard-Kopfzeile' 
            then @$parent.fields.default_header.id 
            else @fields.header.id

        footerId: ->
            if @fields.default_footer is 'Standard-Fußzeile'
            then @$parent.fields.default_footer.id
            else @fields.footer.id

        mainClass: ->
            'cm-page-transparent-header': @fields.header_background is 'transparent'

    methods: 
        defaultFields: ->
            meta_title: [],
            meta_description: []
            default_header: 'Standard-Kopfzeile'
            default_footer: 'Standard-Fußzeile'
            header: [],
            header_background: 'standard'
            footer: [],
            content: []

        getContent: (uid) ->
            unless uid 
                uid = @$parent.fields.start_page.uid
                @$router.replace "/" + uid

            @$prismic.client.getByUID('page', uid).then (document) =>
                if not document then @$router.replace '/not-found'
                @documentId = document.id
                fields = 
                    meta_title: document.data.meta_title
                    meta_description: document.data.meta_description
                    default_header: document.data.default_header
                    default_footer: document.data.default_footer
                    header: document.data.header
                    header_background: document.data.header_background
                    footer: document.data.footer
                    content: document.data.content
                $.extend @fields, fields

                @updateScripts()
            #    $('#prismic-script').remove('')
            #    $('head').append "<script id='prismic-script' src='https://static.cdn.prismic.io/prismic.min.js'>"

        #clear: ->
        #    @$set(@fields, @defaultFields())

    created: ->
        uid = @$route.params.uid
        @getContent(uid)
}
